import { BrowserRouter, Routes, Route } from "react-router-dom";
// import { Box } from "@mui/material";
import {
  Home,
  Navbar,
  Privacy,
  Terms,
  ScrollToTop,
  Tokenomics,
  FrequentAsk,
  Ecosystem,
} from "./components";

const App = () => (
  <BrowserRouter>
    <ScrollToTop />
    <Navbar />
    <Routes>
      <Route path="/" exact element={<Home />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/tokenomics" element={<Tokenomics />} />
      <Route path="/faq" element={<FrequentAsk />} />
      <Route path="/ecosystem" element={<Ecosystem />} />
    </Routes>
    {/* <Footer /> */}
    {/* <Foot /> */}
  </BrowserRouter>
);

export default App;
